export const initialState = {
  carts: [],
};
